import commonApi from './CommonApi.js';
var qs = require('querystring');

export default {
	getAll: async (parameter) => {
		return await commonApi().get('/v1/sps/recognitionOfEquivalenceNotifications/getAll', {
			params: parameter,
			paramsSerializer: (params) => {
				return qs.stringify(params);
			}
		})
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error)
				return {};
			});
	},
	getAzure: async (parameter) => {
		return await commonApi().get('/v1/sps/recognitionOfEquivalenceNotifications/getAzure',
			{
				params: parameter,
				paramsSerializer: (params) => {
					return qs.stringify(params);
				}
			})
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error)
				return {};
			});
	},
	getById: async (parameters) => {
		return await commonApi().get('/v1/sps/recognitionOfEquivalenceNotifications/getById', { params: parameters })
			.then((response) => {
				return response.data;
			})
			.catch((error) => {
				console.log(error.response);
			});
	},
	create: async (viewModel) => {

		return await commonApi().post('/v1/sps/recognitionOfEquivalenceNotifications?language=' + window.currentLanguageEnum, viewModel)
			.then((response) => {
				return response;
			})
			.catch((error) => {
				return error.response;
			});
	},
	edit: async (viewModel) => {
		return await commonApi().put('/v1/sps/recognitionOfEquivalenceNotifications?language=' + window.currentLanguageEnum, viewModel)
			.then((response) => {
				return response;
			})
			.catch((error) => {
				return error.response;
			});
	},
	delete: async (parameters) => {
		return await commonApi().delete('/v1/sps/recognitionOfEquivalenceNotifications', { params: parameters })
			.then((response) => {
				return response;
			})
			.catch((error) => {
				console.log(error.response);
			});
	},
	submit: async (viewModel) => {
		return await commonApi().post('/v1/sps/recognitionOfEquivalenceNotifications/submit?language=' + window.currentLanguageEnum, viewModel)
			.then((response) => {
				return response;
			})
			.catch((error) => {
				return error.response;
			});
	},
	uploadFile: async (formData) => {
		return await uploadApi().post('/v1/notificationAttachments/uploadFile',
			formData, {
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'multipart/form-data'
			}
		})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				return error.response;
			});
	}
}